import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/client";
import { Alert } from "../components/Ui";

const GAME_PRESETS = {
  custom: { label: "Custom", fields: "2", tagOne: "Enter your User ID", tagTwo: "Enter your Zone ID", playerCheckBtn: "no" },
  mlbb: { label: "MLBB (UserID + ZoneID)", fields: "2", tagOne: "Enter your User ID", tagTwo: "Enter your Zone ID", playerCheckBtn: "yes" },
  pubg: { label: "PUBG (UserID only)", fields: "1", tagOne: "Enter your User ID", tagTwo: "", playerCheckBtn: "no" },
  bgmi: { label: "BGMI (Player ID only)", fields: "1", tagOne: "Enter your BGMI Player ID", tagTwo: "", playerCheckBtn: "no" },
  genshin: { label: "Genshin / HSR (UserID + Server)", fields: "2", tagOne: "Enter your UID", tagTwo: "Select Server", playerCheckBtn: "no", serverType: "select", servers: "Asia,America,Europe,TW/HK/MO" },
  honkai: { label: "Honkai Star Rail (UserID + Server)", fields: "2", tagOne: "Enter your UID", tagTwo: "Select Server", playerCheckBtn: "no", serverType: "select", servers: "Asia,America,Europe,TW/HK/MO" },
  zzz: { label: "Zenless Zone Zero (UserID + Server)", fields: "2", tagOne: "Enter your UID", tagTwo: "Select Server", playerCheckBtn: "no", serverType: "select", servers: "Asia,America,Europe,TW/HK/MO" },
  hok: { label: "Honor of Kings (UserID + Login)", fields: "2", tagOne: "Enter your User ID", tagTwo: "Select Login Method", playerCheckBtn: "no", serverType: "select", servers: "Open ID Login,WeChat Login" },
  singleid: { label: "Single ID only", fields: "1", tagOne: "Enter your User ID", tagTwo: "", playerCheckBtn: "no" },
};

export default function AdminProductCreate() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "", category: "Popular Games", company: "", desc: "",
    api: "no", apiName: "", region: "", fields: "2",
    tagOne: "Enter your User ID", tagTwo: "Enter your Zone ID",
    playerCheckBtn: "no", gameType: "custom",
  });
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  function applyPreset(type) {
    const p = GAME_PRESETS[type];
    if (!p) return;
    setForm((f) => ({
      ...f, gameType: type, fields: p.fields, tagOne: p.tagOne, tagTwo: p.tagTwo,
      playerCheckBtn: p.playerCheckBtn,
    }));
  }

  function handleImage(e) {
    const file = e.target.files[0];
    if (!file) return;
    setImage(file);
    setPreview(URL.createObjectURL(file));
  }

  async function submit(e) {
    e.preventDefault();
    if (!form.name) return setError("Product name is required.");
    setBusy(true); setError(null);
    try {
      const fd = new FormData();
      const preset = GAME_PRESETS[form.gameType];
      Object.entries(form).forEach(([k, v]) => { if (k !== "gameType") fd.append(k, v); });
      if (preset && preset.serverType === "select") {
        fd.append("tagTwoType", "select");
        fd.append("tagTwoOptions", preset.servers);
      }
      if (image) fd.append("image", image);
      const { data } = await api.post("/admin/products", fd, { headers: { "Content-Type": "multipart/form-data" } });
      navigate(`/admin/products/${data.product._id}`);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }

  return (
    <div style={{ maxWidth: 600 }}>
      <h1>Add product</h1>

      <div style={{ marginBottom: 20 }}>
        <label className="muted small" style={{ display: "block", marginBottom: 6 }}>Product image</label>
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          {preview && <img src={preview} alt="" style={{ width: 64, height: 64, borderRadius: 12, objectFit: "cover" }} />}
          <input type="file" accept="image/*" onChange={handleImage} />
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 16 }}>
        <label><span className="muted small">Product name *</span>
          <input className="input" value={form.name} onChange={(e) => set("name", e.target.value)} placeholder="MOBILE LEGENDS (INDIA)" /></label>
        <label><span className="muted small">Company</span>
          <input className="input" value={form.company} onChange={(e) => set("company", e.target.value)} placeholder="Moonton" /></label>
        <label><span className="muted small">Category</span>
          <input className="input" value={form.category} onChange={(e) => set("category", e.target.value)} /></label>
        <label><span className="muted small">Fulfilment</span>
          <select className="input" value={form.api} onChange={(e) => set("api", e.target.value)}>
            <option value="no">Manual</option><option value="yes">Auto (API)</option>
          </select></label>

        {form.api === "yes" && (<>
          <label><span className="muted small">API provider</span>
            <select className="input" value={form.apiName} onChange={(e) => set("apiName", e.target.value)}>
              <option value="">Select…</option>
              <option value="smileOne">SmileOne</option>
              <option value="yokcash">Yokcash</option>
              <option value="bgmi">BGMI (Busan API)</option>
            </select></label>
          <label><span className="muted small">Region</span>
            <select className="input" value={form.region} onChange={(e) => set("region", e.target.value)}>
              <option value="">Select…</option><option value="brazil">Brazil</option><option value="philippines">Philippines</option>
            </select></label>
        </>)}

        <label style={{ gridColumn: "1 / -1" }}><span className="muted small">Game Type (auto-fills fields)</span>
          <select className="input" value={form.gameType} onChange={(e) => applyPreset(e.target.value)}>
            {Object.entries(GAME_PRESETS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
          </select></label>

        <label><span className="muted small">Number of input fields</span>
          <select className="input" value={form.fields} onChange={(e) => set("fields", e.target.value)}>
            <option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option>
          </select></label>
        <label><span className="muted small">Player check</span>
          <select className="input" value={form.playerCheckBtn} onChange={(e) => set("playerCheckBtn", e.target.value)}>
            <option value="no">Disabled</option><option value="yes">Enabled</option>
          </select></label>
        <label><span className="muted small">Field 1 label</span>
          <input className="input" value={form.tagOne} onChange={(e) => set("tagOne", e.target.value)} /></label>
        {parseInt(form.fields) >= 2 && <label><span className="muted small">Field 2 label</span>
          <input className="input" value={form.tagTwo} onChange={(e) => set("tagTwo", e.target.value)} /></label>}
      </div>

      <label style={{ display: "block", marginBottom: 16 }}><span className="muted small">Description</span>
        <textarea className="input" rows={4} value={form.desc} onChange={(e) => set("desc", e.target.value)}
          placeholder="Instructions for the customer…" style={{ width: "100%", resize: "vertical" }} /></label>

      <Alert>{error}</Alert>
      <button className="btn primary" onClick={submit} disabled={busy}>{busy ? "Creating…" : "Create product"}</button>
    </div>
  );
}